import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AppProvider } from "@/context/AppContext";
import BookingPage from "@/pages/BookingPage";
import AdminPage from "@/pages/AdminPage";
import PayPage from "@/pages/PayPage";

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BookingPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/pay/:bookingId" element={<PayPage />} />
          <Route path="/pay/:bookingId/return" element={<PayPage />} />
          <Route path="/pay/:bookingId/cancel" element={<PayPage />} />
          <Route path="*" element={<BookingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        richColors
        closeButton
        duration={3000}
      />
    </AppProvider>
  );
}
